/* eslint-disable no-bitwise */
'use strict';

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = typeof window !== 'undefined';
var shareData = isClient ? require('@ali/share-data') : {};
var net = isClient ? require('@ali/network') : {};
var ua = isClient ? require('@ali/simple-ua') : {};

var _require = require('./constant'),
    SHARE_TYPE = _require.SHARE_TYPE;

var isNews = require('../../utils/is_news');
var isIflow = require('../../utils/is_iflow'); // 是否为信息流模式
var isIOS = require('../../utils/is_ios');
var getLocale = require('../../utils/get_locale');
var openIframe = require('../../utils/open_iframe');
var openWindow = require('../../utils/open_window');
var ShareIntl = isClient ? require('@ali/share-intl') : {};
var isUCBrowser = require('../../utils/is_uc_browser');
var storage = isClient ? require('@ali/simple-storage') : {};
var getShareContent = require('./get_share_content');
var debug = require('../../utils/debug');
var getFactParam = require('../../utils/get_fact_param');
var isInBlackListFromClient = require('../app_link/black_list_from_client');
var jssdkShare = require('./jssdkShare');

module.exports = {
  tryToWhatsAppShare: function tryToWhatsAppShare(config) {
    var link = config.__shareContent.link;
    // 因为whatsapp最终没有在share-intl进行跳转分享，所以需要单独做一下分享传播的处理
    // 20180814 ，由于 share-data 产生的异常较多，暂时移除
    // link = addShareDataParam2Link(link);

    openWhatsAppShare(config, link);
  },
  tryToFbShare: function tryToFbShare(config) {
    var _config$__shareConten = config.__shareContent,
        title = _config$__shareConten.title,
        img = _config$__shareConten.img,
        desc = _config$__shareConten.desc,
        link = _config$__shareConten.link,
        redirectLink = _config$__shareConten.redirectLink;

    var fbShareUrl = ShareIntl.facebook(title, desc, link, img, redirectLink);
    var fbIsBanned = getLocale('share_control.fb_banned');
    if (fbIsBanned !== true) {
      doSuccessLog(config);
      if (isIOS()) {
        window.location.href = fbShareUrl;
      } else {
        openWindow(fbShareUrl);
      }
    } else {
      doFailLog(config);
      this.switchShareType(config);
    }
  },
  tryToVkShare: function tryToVkShare(config) {
    var _config$__shareConten2 = config.__shareContent,
        title = _config$__shareConten2.title,
        img = _config$__shareConten2.img,
        desc = _config$__shareConten2.desc,
        link = _config$__shareConten2.link;

    var vkShareUrl = ShareIntl.vk(title, desc, link, img);
    var vkIsBanned = getLocale('share_control.vk_banned');
    // vk分享链接长度有限制，如果太长，截掉__ispec，偏定制，后面再优化
    var isDelIspec = config.isDelIspec,
        isDelDesc = config.isDelDesc;

    if (isDelIspec) {
      vkShareUrl = vkShareUrl.replace(/__ispec.+?%26/g, '');
    }
    if (isDelDesc) {
      vkShareUrl = vkShareUrl.replace(/description.+?&/g, '');
    }
    if (vkIsBanned !== true) {
      doSuccessLog(config);
      if (isIOS()) {
        window.location.href = vkShareUrl;
      } else {
        openWindow(vkShareUrl);
      }
    } else {
      doFailLog(config);
      this.switchShareType(config);
    }
  },
  tryToVkCliShare: function tryToVkCliShare(config) {
    var _this = this;

    var _config$__shareConten3 = config.__shareContent,
        title = _config$__shareConten3.title,
        img = _config$__shareConten3.img,
        desc = _config$__shareConten3.desc,
        link = _config$__shareConten3.link;

    var vkShareUrl = ShareIntl.vkCli(title, desc, link, img);
    var wait = config.vkCliWait;
    var vkIsBanned = getLocale('share_control.vk_banned');
    if (vkIsBanned !== true && !isInBlackListFromClient()) {
      // // 方法1：调applink，不太行
      // callRightNow({
      //   appType: appType.COMMON,
      //   url: vkShareUrl,
      //   waitTime: 1500,
      //   success: () => {
      //     doSuccessLog(config);
      //   },
      //   fail: () => {
      //     doFailLog(config);
      //     this.switchShareType(config);
      //   },
      // });
      // // 方法二：
      // 在黑名单app内，不使用此分享
      // 先调用，3s内还没有hidden，则调用失败，换下一种分享方式
      var maxCount = wait || 1500; // 1.5 seconds
      var preInterval = 20; // every 20ms
      var interval = null;
      var count = 0;
      var isStop = false;
      if (isIOS()) {
        window.location.href = vkShareUrl;
      } else {
        openWindow(vkShareUrl);
      }
      var isHidden = false;
      document.addEventListener('visibilitychange', function () {
        var hidden = document.hidden || document.webkitHidden || document.msHidden;
        if (hidden === true) {
          isHidden = true;
        }
      });
      interval = setInterval(function () {
        if (isHidden === true) {
          doSuccessLog(config);
        }
        count += preInterval;
        if (count >= maxCount && !isStop) {
          clearInterval(interval);
          interval = null;
          isStop = true;
          if (isHidden === false) {
            doFailLog(config);
            _this.switchShareType(config);
          }
        }
      }, preInterval);
    } else {
      doFailLog(config);
      this.switchShareType(config);
    }
  },
  tryToOkShare: function tryToOkShare(config) {
    var link = config.__shareContent.link;

    var okShareUrl = ShareIntl.ok(link);
    var okIsBanned = getLocale('share_control.ok_banned');
    if (okIsBanned !== true) {
      doSuccessLog(config);
      if (isIOS()) {
        window.location.href = okShareUrl;
      } else {
        openWindow(okShareUrl);
      }
    } else {
      doFailLog(config);
      this.switchShareType(config);
    }
  },
  tryToClientShare: function tryToClientShare(config) {
    var _config$__shareConten4 = config.__shareContent,
        title = _config$__shareConten4.title,
        img = _config$__shareConten4.img,
        desc = _config$__shareConten4.desc,
        link = _config$__shareConten4.link;

    if (isNews()) {
      shareJSSDKClient({ title: title, img: img, desc: desc, link: link });
    } else if (isUCBrowser()) {
      shareClientUCBrowser({ title: title, img: img, desc: desc, link: link });
    } else {
      doFailLog(config);
      this.switchShareType(config);
    }
  },
  tryToClientWhatsappShare: function tryToClientWhatsappShare(config) {
    var _config$__shareConten5 = config.__shareContent,
        title = _config$__shareConten5.title,
        img = _config$__shareConten5.img,
        desc = _config$__shareConten5.desc,
        link = _config$__shareConten5.link;

    if (isNews()) {
      shareWhatsatppJSSDKClient({ title: title, img: img, desc: desc, link: link });
    }
  },
  tryToJsSdkShare: function tryToJsSdkShare(config) {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _config$__shareConten6, desc, link;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _config$__shareConten6 = config.__shareContent, desc = _config$__shareConten6.desc, link = _config$__shareConten6.link;
              _context.prev = 1;
              _context.next = 4;
              return jssdkShare('com.whatsapp', desc + '\n' + link);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](1);

              // 降级
              _this2.switchShareType(config);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 6]]);
    }))();
  },
  btnToHidden: function btnToHidden(config) {
    config.__target && (config.__target.style = 'display:none');
  },
  toDownload: function toDownload(config) {
    config.downloadUrl && openWindow(config.downloadUrl);
  },
  switchShareType: function switchShareType(config) {
    var _this3 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var __this, __tmpShareBackupList, allFail, afterClick, shareType;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __this = module.exports;
              __tmpShareBackupList = config.__tmpShareBackupList, allFail = config.allFail, afterClick = config.afterClick;

              if (!(__tmpShareBackupList.length >= 1)) {
                _context2.next = 29;
                break;
              }

              shareType = __tmpShareBackupList.shift();

              config.__shareType = shareType;
              // 保存分享的内容
              _context2.t0 = config.__shareContent;

              if (_context2.t0) {
                _context2.next = 10;
                break;
              }

              _context2.next = 9;
              return getShareContent(config);

            case 9:
              _context2.t0 = _context2.sent;

            case 10:
              config.__shareContent = _context2.t0;

              // 日志内容
              doStandardLog(config);
              _context2.t1 = shareType;
              _context2.next = _context2.t1 === SHARE_TYPE.FB ? 15 : _context2.t1 === SHARE_TYPE.WHATSAPP ? 16 : _context2.t1 === SHARE_TYPE.WHATSAPP_CLIENT ? 17 : _context2.t1 === SHARE_TYPE.CLIENT ? 18 : _context2.t1 === SHARE_TYPE.VK ? 19 : _context2.t1 === SHARE_TYPE.OK ? 20 : _context2.t1 === SHARE_TYPE.HIDDEN ? 21 : _context2.t1 === SHARE_TYPE.DOWNLOAD ? 22 : _context2.t1 === SHARE_TYPE.VK_CLIENT ? 23 : _context2.t1 === SHARE_TYPE.JSSDK ? 24 : 26;
              break;

            case 15:
              return _context2.abrupt('return', __this.tryToFbShare(config));

            case 16:
              return _context2.abrupt('return', __this.tryToWhatsAppShare(config));

            case 17:
              return _context2.abrupt('return', __this.tryToClientWhatsappShare(config));

            case 18:
              return _context2.abrupt('return', __this.tryToClientShare(config));

            case 19:
              return _context2.abrupt('return', __this.tryToVkShare(config));

            case 20:
              return _context2.abrupt('return', __this.tryToOkShare(config));

            case 21:
              return _context2.abrupt('return', __this.btnToHidden(config));

            case 22:
              return _context2.abrupt('return', __this.toDownload(config));

            case 23:
              return _context2.abrupt('return', __this.tryToVkCliShare(config));

            case 24:
              console.log(123);
              return _context2.abrupt('return', __this.tryToJsSdkShare(config));

            case 26:
              return _context2.abrupt('return', __this.tryToFbShare(config));

            case 27:
              _context2.next = 31;
              break;

            case 29:
              typeof afterClick === 'function' && afterClick(config.__shareContent);
              typeof allFail === 'function' && allFail();

            case 31:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
};

// 避免多次点击产生多个 timer 的情况
var trywhatsappTimer = null;
function tryWhatsAppDeepLink(link, config) {
  window.clearTimeout(trywhatsappTimer);
  var _config$waitTime = config.waitTime,
      waitTime = _config$waitTime === undefined ? 3000 : _config$waitTime;

  openIframe(link);

  // 原理：N 秒内页面切换成 hidden 了，那就判定为分享成功，否则超时就执行回落操作

  var visibilityChange = function visibilityChange() {
    if (document.hidden || document.webkitHidden || document.msHidden) {
      debug('whatsapp 唤起成功');
      window.clearTimeout(trywhatsappTimer);
      document.removeEventListener('visibilitychange', visibilityChange, false);
      // 统计日志
      doSuccessLog(config);
    }
  };
  var fallback = function fallback() {
    document.removeEventListener('visibilitychange', visibilityChange, false);
    // 统计日志
    doFailLog(config);
    // 唤起失败
    module.exports.switchShareType(config);
  };
  document.addEventListener('visibilitychange', visibilityChange, false);
  trywhatsappTimer = window.setTimeout(fallback, waitTime);
}

function doStandardLog(_ref) {
  var logParams = _ref.logParams,
      _ref$__shareContent = _ref.__shareContent,
      __shareContent = _ref$__shareContent === undefined ? '' : _ref$__shareContent,
      scene = _ref.scene;

  var __tidx = __shareContent.__tidx,
      __didx = __shareContent.__didx,
      __iidx = __shareContent.__iidx;

  logParams = (0, _extends3.default)({}, logParams, {
    titleidx: __tidx,
    descidx: __didx,
    imgidx: __iidx,
    scene: scene
  });
  var _logParams = logParams,
      ckId = _logParams.ckId,
      params = (0, _objectWithoutProperties3.default)(_logParams, ['ckId']);
  // 业务自定义统计

  require('@ali/log').logClick(ckId || 'share', params);
  // 标准统计
  require('@ali/log').share(getFactParam(logParams));
}

function doSuccessLog(config) {
  var shareBackupList = config.shareBackupList,
      _config$logParams = config.logParams,
      ckId = _config$logParams.ckId,
      params = (0, _objectWithoutProperties3.default)(_config$logParams, ['ckId']),
      shareType = config.__shareType,
      afterClick = config.afterClick;
  // 设置缓存用于修改样式

  storage.setLocal(shareType + 'CannotShare', false);

  typeof afterClick === 'function' && afterClick(config.__shareContent);

  require('@ali/log').logEvent('bucket', 'shareSuccess', (0, _extends3.default)({
    shareBackupList: shareBackupList,
    shareType: shareType,
    ckId: ckId
  }, params));
}

function doFailLog(config) {
  var shareBackupList = config.shareBackupList,
      _config$logParams2 = config.logParams,
      ckId = _config$logParams2.ckId,
      params = (0, _objectWithoutProperties3.default)(_config$logParams2, ['ckId']),
      shareType = config.__shareType,
      eachFail = config.eachFail,
      __shareContent = config.__shareContent;

  // 设置缓存用于修改样式

  storage.setLocal(shareType + 'CannotShare', true);

  require('@ali/log').logEvent('bucket', 'shareFail', (0, _extends3.default)({
    shareBackupList: shareBackupList,
    shareType: shareType,
    ckId: ckId
  }, params));

  // 每个分享方法失效之后的回调方法
  typeof eachFail === 'function' && eachFail({ shareType: shareType, shareContent: __shareContent });
}

function shareJSSDKClient(_ref2) {
  var title = _ref2.title,
      link = _ref2.link;

  // url跟title，在新版中会支持
  window.ucapi.share.shareTo({
    id: 'More',
    name: 'More',
    url: link,
    title: title,
    success: function success(result) {
      console.log(result);
    }
  });
}

function shareWhatsatppJSSDKClient(_ref3) {
  var title = _ref3.title,
      link = _ref3.link;

  // url跟title，在新版中会支持
  window.ucapi.share.shareTo({
    id: 'Whatsapp',
    name: 'Whatsapp',
    url: link,
    title: title,
    success: function success(result) {
      console.log(result);
    }
  });
}

function shareClientUCBrowser(_ref4) {
  var title = _ref4.title,
      img = _ref4.img,
      desc = _ref4.desc,
      link = _ref4.link;

  ShareIntl.ucShare({ title: title, img: img, desc: desc, link: link });
}

// eslint-disable-next-line no-unused-vars
function addShareDataParam2Link(link) {
  var SHARE_DATA_PARAM_NAME = '__sd';
  var shareDataReg = new RegExp(SHARE_DATA_PARAM_NAME + '=[^&]*[&]', 'g');
  try {
    var lastNodeDeep = 0;
    try {
      lastNodeDeep = shareData.decodeShareData(net.query(SHARE_DATA_PARAM_NAME)).deep;
    } catch (e) {
      console.log(e);
    }
    link = net.parseQuery({
      __sd: shareData.encodeShareData({
        sessionid: ua.getSessionId(),
        deep: ++lastNodeDeep,
        type: 0, // 0: 链接, 1: 图片
        style: 0 // 样式id保留后续用作优化分享
      })
    }, link.replace(shareDataReg, ''));
  } catch (e) {
    console.log(e);
  }
  return link;
}

function openWhatsAppShare(config, link) {
  var _config$waitTime2 = config.waitTime,
      waitTime = _config$waitTime2 === undefined ? 3000 : _config$waitTime2;
  var title = config.__shareContent.title;


  title = decodeURIComponent(title); // 为了防止多次encode之后出现的编码问题，encode之前确保title是没有encode过的

  var whatsAppShareUrl = 'whatsapp://send?text=' + encodeURIComponent(title) + '%20' + encodeURIComponent(link);
  if ((isIflow() || isNews()) && !isIOS()) {
    var isMatch = false;
    var timer1 = void 0;
    window.ucapi && window.ucapi.share.getShareApp({
      success: function success(result) {
        if (result && Array.isArray(result.apps)) {
          result.apps.forEach(function (item) {
            if (item.id.toLowerCase() === 'whatsapp') {
              isMatch = true;
            }
          });
        }
        if (isMatch) {
          // 统计打点

          // News必须是window.location.href才能完成唤起WhatsApp，window.open会直接跳错误页面,iframe则没有任何反应
          // window.location.href = whatsAppShareUrl;
          // !!no more news!!
          window.ucapi && window.ucapi.share.shareTo({
            id: 'Whatsapp',
            name: 'Whatsapp',
            url: link,
            title: title,
            need_shorten: false, // bucket已经短链一次
            success: function success() {
              doSuccessLog(config);
            },
            fail: function fail() {
              doFailLog(config);
              module.exports.switchShareType(config);
            }
          });
        } else {
          module.exports.switchShareType(config);
        }
        clearTimeout(timer1);
      }
    });
    // 超时处理
    timer1 = setTimeout(function () {
      doFailLog(config);
      module.exports.switchShareType(config);
    }, waitTime);
  } else {
    tryWhatsAppDeepLink(whatsAppShareUrl, config);
  }
}